const { getAxiosInstance } = require('../connection');

module.exports = {
    saveScenarios: function (eventId, data) {
        return getAxiosInstance({
            url: `/events/${eventId}/matchmaking/scenarios`,
            method: 'put',
            json: true,
            data,
        }).then((response) => response.data);
    },
};
